import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "nav-bar" }
const _hoisted_2 = ["onSubmit"]
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Today")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("60 minutes")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("16 days")

import axios from "axios";
import { ref } from "vue";
import router from "@/router/index";
import Forecast from "@/types/Forecast";


export default /*#__PURE__*/_defineComponent({
  __name: 'NavBar',
  setup(__props) {

const searchInput = ref("");

// eslint-disable-next-line 
router.beforeEach((to, from) => {
  localStorage.setItem("page", to.name as string)
  return true
})

const pageStorage = localStorage.getItem("page")
let page: string
if(pageStorage) {
  page = pageStorage
}

const getCurrentWeatherByCity = async () => {
  try {
    const res = await axios.get(`https://api.weatherbit.io/v2.0/current?city=${searchInput.value}&key=${process.env.VUE_APP_API_KEY}&include=minutely`);

    const daily = await axios.get(
      `https://api.weatherbit.io/v2.0/forecast/daily?city=${searchInput.value}&key=${process.env.VUE_APP_API_KEY}`
    );

    let minutelyForecasts: Forecast[];

    let currentWeather = {
      city: "",
      date: "",
      description: "",
      feelsLike: "",
      icon: "",
      temperature: 0,
      lat: "",
      lon: ""
    }

    currentWeather.city = res.data.data[0].city_name;
    currentWeather.date = new Date(res.data.data[0].ob_time).toDateString();
    currentWeather.description = res.data.data[0].weather.description;
    currentWeather.feelsLike = res.data.data[0].temp;
    currentWeather.icon = res.data.data[0].weather.icon + ".png";
    currentWeather.temperature = Math.floor(res.data.data[0].temp);
    currentWeather.lat = res.data.data[0].lat;
    currentWeather.lon = res.data.data[0].lon;

    minutelyForecasts = res.data.minutely;

    localStorage.setItem("currentWeather", JSON.stringify(currentWeather));
    localStorage.setItem("minutelyForecasts", JSON.stringify(minutelyForecasts));
    localStorage.setItem("dailyForecasts", JSON.stringify(daily.data.data))
    
    router.push("/")
    if(page === "home") {
      location.reload()
    }
  } catch (error) {
    console.log(error);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("form", {
      onSubmit: _withModifiers(getCurrentWeatherByCity, ["prevent"])
    }, [
      _withDirectives(_createElementVNode("input", {
        type: "text",
        class: "form-control nav-bar__input-search",
        placeholder: "Search for cities",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchInput).value = $event)),
        required: ""
      }, null, 512), [
        [_vModelText, searchInput.value]
      ])
    ], 40, _hoisted_2),
    _createElementVNode("nav", null, [
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, {
          "active-class": "active",
          to: "/"
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, {
          "active-class": "active",
          to: "/60m-forecast"
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, {
          "active-class": "active",
          to: "/16d-forecast"
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})